import { api } from "../../../utils/api";

export const putLead = async (data) => {
  const id = data.lead_id;
  delete data.lead_id;
  try {   
    const response = await api.put(`lead/${id}`, data);
    // console.log(response.data)
    return response.data;
  } catch (error) {
    throw error;;
  }
};
